import React from 'react'
import styled from 'styled-components'
import { Controller } from 'react-hook-form'

import { FieldWrapper, validationRules } from '..'
import { SingleSelectFieldProps, MultiSelectFieldProps } from './SelectField.types'
import { SingleSelect, MultiSelect, MultiCheckBoxSelect } from '../../../ui-elements/Select'

import { styleTheme } from '../../../../style/theme'

export const SingleSelectField = (props: SingleSelectFieldProps) => <StyledSingleSelectComponent {...props} />

const SingleSelectComponent = (props: SingleSelectFieldProps & { className?: string }) => {
  const { label, required } = props

  return (
    <FieldWrapper
      label={props.label}
      error={props.error}
      isRequired={props.required}
      column={props.column}
      labelClassName={props.labelClassName}
      fieldClassName={props.fieldClassName}
    >
      <Controller
        {...props}
        render={({ field }) => (
          <SingleSelect
            {...props}
            {...field}
            placeholder={props.placeholder || '選択してください'}
            onChange={(opt) => field.onChange(opt?.value || null)}
            value={props.options.find((opt) => opt.value === field.value)}
            isClearable={!props.required}
            className={`${props.className} single-select ${props.error ? 'error' : ''}`}
            isSearchable={props.isSearchable}
          />
        )}
        rules={{ required: required && validationRules.requiredSelect(label) }}
      />
    </FieldWrapper>
  )
}

export const StyledSingleSelectComponent = styled(SingleSelectComponent)`
  &.single-select {
    &.error {
      border: 1px solid ${styleTheme.colors.pink.base};
    }
  }
`

export const MultiSelectField = (props: MultiSelectFieldProps) => <StyledMultiSelectComponent {...props} />

const MultiSelectComponent = (props: MultiSelectFieldProps & { className?: string }) => {
  const { label, required } = props

  return (
    <FieldWrapper
      label={props.label}
      error={props.error}
      isRequired={props.required}
      column={props.column}
      labelClassName={props.labelClassName}
      fieldClassName={props.fieldClassName}
    >
      <Controller
        {...props}
        render={({ field }) => {
          const fieldValue = (field.value as (string | number)[]) || []
          return (
            <MultiSelect
              {...props}
              {...field}
              placeholder={props.placeholder || '選択してください'}
              onChange={(opts) => field.onChange(opts.map((opt) => opt.value))}
              value={props.options.filter((opt) => fieldValue.includes(opt.value))}
              className={`${props.className} multi-select ${props.error ? 'error' : ''}`}
            />
          )
        }}
        rules={{ required: required && validationRules.requiredSelect(label) }}
      />
    </FieldWrapper>
  )
}

export const StyledMultiSelectComponent = styled(MultiSelectComponent)`
  &.multi-select {
    &.error {
      border: 1px solid ${styleTheme.colors.pink.base};
    }
  }
`

